<template>
    <div class="chart_container ml-0">
        <Doughnut :chart-data="chartData" :chart-options="chartOptions" :plugins="plugins"/>
        <div class="col text-center h5 mt-0">
            {{ $t('Deficit' + budgetType) }}{{ unfunded | formatMoney }}
        </div>    
    </div>
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut } from 'vue-chartjs/legacy'
ChartJS.register(ArcElement, Tooltip, Legend)

const gaugeNeedle = {
    id: 'gaugeNeedle',
            // eslint-disable-next-line
    afterDatasetDraw(chart, args, options) {
            // eslint-disable-next-line
        const { ctx, config, data, chartArea: { top, bottom, left, right, width, height } } = chart;

        ctx.save();

        const dataTotal = data.datasets[0].data.reduce((a, b) => a + b, 0);
        const needleValue = data.datasets[0].needleValue;
        const angle = Math.PI + (1 / dataTotal * needleValue * Math.PI)
        const chartX = width / 2;
        const chartY = chart._metasets[0].data[0].y;

        //needle
        ctx.translate(chartX, chartY);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(0, -4);
        ctx.lineTo(chartX + 20, 0);
        ctx.lineTo(0, 4);
        ctx.fillStyle = '#444';
        ctx.fill();
        ctx.restore();
        //needle dot
        ctx.beginPath();
        ctx.arc(chartX, chartY, 6, 0, 10);
        ctx.fill();
        ctx.restore();

        ctx.font = '40px  Source Sans Pro';
        ctx.fillStyle = '#444';
        ctx.fillText(parseInt(100 * needleValue / dataTotal) + '%', chartX, chartY + 40);
        ctx.textAlign = "center";
        ctx.restore();
    }
}

export default { 
    props: ['funded','unfunded', 'budgetType'],
    components: {
        Doughnut,
    },

    data() {
        return {
            plugins: [gaugeNeedle],
        }
    },
    computed: {
        chartData() {
            return {
                labels: [this.$t('Total amount funded' + this.budgetType),this.$t('Total amount unfunded' +this.budgetType)],
                datasets: [{
                    backgroundColor: ['rgb(0 122 179)', 'rgb(253 185 36)',],
                    data: [this.funded,this.unfunded],
                    needleValue: this.funded,
                }]
            }
        },

        chartOptions() {
            return {
                rotation: 270,
                circumference: 180,
                cutoutPercentage: 70,
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (context) => this.formatLabel(context),
                        }
                    }
                }
            }
        }
    },

    methods: {
        formatMoney(val) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
 }).format(val);
        },
        formatLabel(context) {
            return context.label + ((process.env.VUE_APP_I18N_LOCALE=== 'en') ? ': ' : ' : ') + this.formatMoney(context.parsed);
        }
    }
}
</script>

<style>
.chart_container {
  margin: auto;
  width: 370px;
}
</style>
